@if (fomularioModificacion) {
  <form [formGroup]="fomularioModificacion" novalidate="">
    <div class="row mb-2">
      <div class="col-sm-12">
        <div class="form-group">
          <label for="contrasenaActual" class="col-form-label-sm">Contraseña actual:</label>
          <input type="password" class="form-control form-control-sm text-center" id="contrasenaActual"
            formControlName="contrasenaActual" placeholder="Ingresa la contraseña actual">
          @if (fomularioModificacion.get('contrasenaActual')?.invalid &&
            fomularioModificacion.get('contrasenaActual')?.errors &&
            (fomularioModificacion.get('contrasenaActual')?.dirty || fomularioModificacion.get('contrasenaActual')?.touched)) {
            <div
              >
              @if (fomularioModificacion.get('contrasenaActual')?.hasError('required')) {
                <small class="text-danger"
                  >
                  Este campo es requerido.
                </small>
              }
            </div>
          }
        </div>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-sm-12">
        <div class="form-group">
          <label for="contrasenaNueva" class="col-form-label-sm">Contraseña nueva:</label>
          <input type="password" class="form-control form-control-sm text-center" id="contrasenaNueva"
            formControlName="contrasenaNueva" placeholder="Ingresa una nueva (sige las recomendaciones abajo)" maxlength="10">
          @if (fomularioModificacion.get('contrasenaNueva')?.invalid &&
            fomularioModificacion.get('contrasenaNueva')?.errors &&
            (fomularioModificacion.get('contrasenaNueva')?.dirty || fomularioModificacion.get('contrasenaNueva')?.touched)) {
            <div>
              @if (fomularioModificacion.get('contrasenaNueva')?.hasError('required')) {
                <small class="text-danger"
                  >
                  Este campo es requerido.
                </small>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </form>
}
<p class="text-danger" style="font-style: italic; font-size: smaller;">**Recomendaciones:</p>
<ul class="text-danger" style="font-style: italic; font-size: smaller;">
  <li>No uses contraseñas anteriores</li>
  <li>No uses datos personales</li>
  <li>Usa caracteres especiales y numeros en vez de letras</li>
  <li>Longitud minima 10 caracteres</li>
</ul>
<div class="text-center">
  <button type="button" class="btn btn-primary btn-sm me-1" (click)="guardar();"
    [disabled]="fomularioModificacion?.invalid">
    <i class="bi bi-check2"></i> Confirmar
  </button>
  <button type="button" ngbAutofocus class="btn btn-outline-secondary btn-sm" (click)="cancelar();">
    <i class="bi bi-x-lg"></i> Cancelar
  </button>
</div>